import { createContext } from 'react';
import { UIState } from './types';

export const UIStateContext = createContext<UIState>({} as UIState);
UIStateContext.displayName = 'UIState';
